var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79116 5.56258L7.26616 6.09925C6.84616 6.51925 6.58366 6.87508 6.58366 7.75008H5.41699V7.45841C5.41699 6.81091 5.67949 6.22758 6.09949 5.80758L6.82283 5.07258C7.03866 4.86258 7.16699 4.57091 7.16699 4.25008C7.16699 3.94066 7.04408 3.64392 6.82528 3.42512C6.60649 3.20633 6.30974 3.08341 6.00033 3.08341C5.69091 3.08341 5.39416 3.20633 5.17537 3.42512C4.95658 3.64392 4.83366 3.94066 4.83366 4.25008H3.66699C3.66699 3.63124 3.91282 3.03775 4.35041 2.60017C4.78799 2.16258 5.38149 1.91675 6.00033 1.91675C6.61916 1.91675 7.21266 2.16258 7.65024 2.60017C8.08783 3.03775 8.33366 3.63124 8.33366 4.25008C8.33282 4.74197 8.13786 5.21365 7.79116 5.56258ZM6.58366 10.0834H5.41699V8.91675H6.58366M6.00033 0.166748C5.23428 0.166748 4.47574 0.317632 3.76801 0.610784C3.06027 0.903937 2.41721 1.33362 1.87554 1.87529C0.781574 2.96925 0.166992 4.45298 0.166992 6.00008C0.166992 7.54718 0.781574 9.03091 1.87554 10.1249C2.41721 10.6665 3.06027 11.0962 3.76801 11.3894C4.47574 11.6825 5.23428 11.8334 6.00033 11.8334C7.54742 11.8334 9.03115 11.2188 10.1251 10.1249C11.2191 9.03091 11.8337 7.54718 11.8337 6.00008C11.8337 2.77425 9.20866 0.166748 6.00033 0.166748Z",
    fill: "#4B69F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7fb09ca21f117173af1d1f8ccf5b90ad.svg";
export { ForwardRef as ReactComponent };